import React from "react";

import "./EmailHeaderView.scss";
import {EmailActions} from '../../actions/EmailActions';
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {formatFromAddressesString} from "../../util/Formatters";
import {OutgoingEmailDto} from "../../services/messages/OutgoingEmailDto";

import {ContentLocation} from "../../locations/ContentLocation";
import {AgGridReact} from "ag-grid-react";
import {ColDef, GridOptions, SelectionChangedEvent} from "ag-grid-community";
import {DefaultGridOptions, DefaultMultiRowSelection, gridTheme, gridThemeDark, RelativeDateTimeRenderer} from "../../util/AgGridUtil";

const gridOptions: GridOptions<OutgoingEmailDto> = {
    ...DefaultGridOptions,
    rowClassRules: {
        "error": params => !!params.data?.RetryCount,
    }
};

const columnDefs: ColDef<OutgoingEmailDto>[] = [
    {
        field: "Address",
        flex: 1,
        valueFormatter: params => formatFromAddressesString(params.value, true),
    },
    {
        field: "RetryCount",
        width: 100,
    },
    {
        field: "NextRetry",
        cellRenderer: RelativeDateTimeRenderer,
    },
];

const OutboxHeaderView = () => {

    const isDarkTheme = useAppSelector(({system}) => system.theme === "dark");

    console.log("Rendering outbox grid...");

    const dispatch = useAppDispatch();

    const items = useAppSelector(({folderState}) => folderState.outgoingEmails);

    function handleSelectionChanged(params: SelectionChangedEvent<OutgoingEmailDto>) {
        if (params.source === "api") {
            return;
        }
        const newSelection = params.api.getSelectedRows();
        dispatch(EmailActions.selectOutgoingEmails(newSelection));
        if (newSelection.length > 0) {
            ContentLocation.showOutboxEmail(newSelection[0].Uid);
        }
    }

    return (
        <div className="content-item-list email-view">
            <AgGridReact<OutgoingEmailDto> theme={isDarkTheme ? gridThemeDark : gridTheme}
                                           gridOptions={gridOptions}
                                           rowSelection={DefaultMultiRowSelection}
                                           rowData={items}
                                           onSelectionChanged={handleSelectionChanged}
                                           columnDefs={columnDefs}
            />
        </div>
    );
};

export default OutboxHeaderView;
